import styled from 'styled-components'
import { COLORS } from 'theme'
import Flex from 'components/Flex'
import { FONT } from 'theme/font'
export const UploadMsgFlex = styled(Flex)`
  height: 100%;
`
export const ShortlistDiv = styled.div`
  font-family: Plus Jakarta Sans;
  font-size: 20px;
  font-weight: 500;
  line-height: ${props => props?.percentHeight || '28px'};
  letter-spacing: 0em;
  text-align: center;
  color: #010e30;
  height: ${props => props?.percentHeight || '28px'};
  width: ${props => props?.percentWeight || '451px'};
  margin-top: 15px;
  margin-bottom: 15px;
`

export const FlexWrap = styled(Flex)`
  position: relative;
  gap: ${props => (props.gap ? props.gap : '0px')};
  padding: ${props => (props.padding ? props.padding : '0px')};
  background-color: ${props => (props.bgColor ? props.bgColor : 'transparent')};
`

export const SubtitleLarge = styled.h2`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_LG};
  line-height: 24px;
  color: ${props => (props.color ? props.color : COLORS.GREY_T_20)};
  margin-bottom: 5px;
`
export const SubtitleMedium = styled.h2`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_BASE};
  line-height: 21px;
  color: ${COLORS.GREY_T_10};
  margin-bottom: 0;
`
export const SubtitleSmall = styled.p`
  font-style: normal;
  font-weight: ${props => (props.fontweight ? props.fontweight : FONT.FW_400)};
  font-size: ${props => (props.fontsize ? props.fontsize : FONT.F_SM)};
  line-height: 20px;
  color: ${props => (props.color ? props.color : COLORS.GREY_T_30)};
  margin-bottom: ${props => (props.marginbottom ? props.marginbottom : '5px')};
  padding: ${props => (props.padding ? props.padding : '')};
  text-transform: ${props => (props.capitalize ? 'capitalize' : 'none')};
  span {
    font-style: normal;
    font-weight: ${FONT.FW_600};
    line-height: 18px;
    color: ${COLORS.GREY_T_10};
    margin-right: 5px;
  }
  ${props => props.afterContent && `::after { content: ',';}`}

  :last-child:after {
    content: '';
  }
`
export const GrayText = styled.p`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_60};
  margin-bottom: 0;
`
export const TextDescription = styled.p`
  width: 80%;
`
export const BoldText = styled.p`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_30};
  margin-bottom: 0;
`
export const LeftSection = styled(Flex)`
  width: 60%;
  gap: 10px;
`
export const RightSection = styled(Flex)`
  width: 40%;
  gap: 10px;
`
export const TitleMedium = styled.h2`
  font-style: normal;
  font-weight: ${props => (props.fontweight ? props.fontweight : FONT.FW_700)};
  font-size: ${FONT.F_2XL};
  line-height: 30px;
  color: ${COLORS.GREY_T_20};
  margin-bottom: 0;
`
export const GrayTextSmall = styled.p`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 30px;
  color: ${props => (props.color ? props.color : COLORS.GREY_T_20)};
  margin-bottom: ${props => (props.marginbottom ? props.marginbottom : '0px')};
  text-transform: ${props => (props.capitalize ? 'capitalize' : 'none')};
`
export const InfoText = styled.p`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${props => (props.fontsize ? props.fontsize : FONT.F_BASE)};
  line-height: 30px;
  color: ${COLORS.GREY_T_50_2};
  margin-bottom: ${props => (props.marginbottom ? props.marginbottom : '0px')};
  margin-left: ${props => (props.marginleft ? props.marginleft : '0px')};
  margin-right: ${props => (props.marginRight ? props.marginRight : '0px')};
  text-transform: ${props => (props.capitalize ? 'capitalize' : 'none')};
  padding-top: ${props => (props.paddingTop ? props.paddingTop : '')};
`
export const YellowBox = styled(Flex)`
  padding: 10px;
  background: ${COLORS.ORANGE_T_92};
  border: 1px solid ${COLORS.ORANGE_T_60};
  border-radius: 10px;
  gap: 15px;
`

export const SkillList = styled.ul`
  padding-inline-start: 20px;
`

export const SubBold = styled.span`
  font-weight: bold;
  color: #343e59;
`

export const Container1 = styled.div`
  height: ${props => (props.expanded ? 'auto' : '250px')};

  overflow: hidden;
  overflow-wrap: break-word;
`

export const Content = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 25px;
  color: #808697;
`

export const ExtraPadding = styled.div`
  padding-bottom: 8px;
`

export const ShowMoreText = styled.span`
  cursor: pointer;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 10px;
  padding-right: 10px;
  color: #000;
  display: ${props => (props.visible ? 'inline-block' : 'none')};
  border-radius: 10px;
  background-color: #e6e7ea;
  width: 30% !important;
  font-weight: bold;
`

export const ShowLessText = styled.span`
  cursor: pointer;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 10px;
  padding-right: 10px;
  color: #000;
  display: ${props => (props.visible ? 'inline-block' : 'none')};
  border-radius: 10px;
  background-color: #e6e7ea;
  width: 25% !important;
  font-weight: bold;
`

export const PopSubHeading = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 25px;
  color: #808697;
  padding-top: 5px;
`

export const YearSpan = styled.span`
  font-style: normal;
  font-size: 15px;
  color: ${COLORS.GREY_T_60};
  margin: 0 5px 15px 0;
`
